import React from "react";
import { withFormik, FormikProps, FormikErrors, Form } from "formik";
import { IntlShape } from "react-intl";

import { TextFieldComponent, ClickableComponent } from "@app/core";
import { SelectComponent } from "@app/core/select";
import { platformType, getTranslatedPlatforms } from "@app/constants/platform";

import styles from "./create-merchant-modal-component.module.scss";

export interface ICreateMerchantFormValues {
  name: string;
  platform: platformType;
}

interface IOtherProps {
  intl: IntlShape;
  isLoading: boolean;
  onCancel: () => void;
}

const InnerForm = (props: IOtherProps & FormikProps<ICreateMerchantFormValues>) => {
  const { touched, errors } = props;

  const translatedPlatforms = getTranslatedPlatforms(props.intl);

  return (
    <Form>
      <div className={styles.form}>
        <div className={styles.formField}>
          <SelectComponent
            height={40}
            onChange={props.handleChange}
            options={translatedPlatforms}
            id="platform"
            label={{
              label: props.intl.formatMessage({ id: "createMerchantForm.input.platform.label" }),
              tooltip: props.intl.formatMessage({ id: "createMerchantForm.input.platform.tooltip" })
            }}
          />
        </div>
        <div className={styles.formField}>
          <TextFieldComponent
            label={{
              label: props.intl.formatMessage({ id: "createMerchantForm.input.name.label" }),
              tooltip: props.intl.formatMessage({ id: "createMerchantForm.input.name.tooltip" }),
              errorMessage: touched.name === true && errors.name
            }}
            placeholder=""
            value={props.values.name}
            onChange={props.handleChange}
            onBlur={props.handleBlur}
            type="text"
            id="name"
            errorMessage={touched.name === true && errors.name}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        <span className={styles.firstButton}>
          <ClickableComponent
            title={props.intl.formatMessage({ id: "createMerchantForm.button.cancel" })}
            onClick={() => {
              props.onCancel();
            }}
            height={48}
            variant="primary-inverted"
          />
        </span>
        <span>
          <ClickableComponent
            buttonType="submit"
            title={props.intl.formatMessage({ id: "createMerchantForm.button.add" })}
            height={48}
            disabled={props.isLoading}
          />
        </span>
      </div>
    </Form>
  );
};

interface IFormProps {
  intl: IntlShape;
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: (values: ICreateMerchantFormValues) => void;
}

export const CreateMerchantFormComponent = withFormik<IFormProps, ICreateMerchantFormValues>({
  mapPropsToValues: () => ({
    platform: 1,
    name: ""
  }),

  validate: (values: ICreateMerchantFormValues, props) => {
    const errors: FormikErrors<ICreateMerchantFormValues> = {};
    if (!values.name) {
      errors.name = props.intl.formatMessage({ id: "createMerchantForm.error.name.required" });
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    bag.props.onSubmit(values);
  }
})(InnerForm);
